import type { PublicKey } from '@solana/web3.js';
import type { SubmissionOptions, SubmissionResult } from '../tx-engine/types.js';
import type { EngineBuildResult } from './retry-submission.js';
export type SubmitTransactionFn = (
  build: EngineBuildResult,
  options: SubmissionOptions,
) => Promise<SubmissionResult>;

/**
 * Contract-SDK builders return `BuildResult` with a `signerKeys` field; the
 * tx-engine expects a `signers` field with the same data. Map between
 * them so the engine's submit pipeline can consume the contract-sdk
 * output directly.
 */
export function toEngineBuildResult(b: {
  instructions: ReadonlyArray<{
    programId: PublicKey;
    keys: ReadonlyArray<{ pubkey: PublicKey; isSigner: boolean; isWritable: boolean }>;
    data: Buffer;
  }>;
  signerKeys: ReadonlyArray<PublicKey>;
  computeUnits: number;
}): Parameters<SubmitTransactionFn>[0] {
  return {
    instructions: b.instructions.map((ix) => ({
      programId: ix.programId,
      keys: ix.keys.map((k) => ({
        pubkey: k.pubkey,
        isSigner: k.isSigner,
        isWritable: k.isWritable,
      })),
      data: ix.data,
    })),
    signers: [...b.signerKeys],
    computeUnits: b.computeUnits,
  };
}
